import { apiHelper } from '@/utils';
import { API } from '@/constants';

export const phoneExtService = {
    getAll,
    store,
    show,
    update,
    updateStatus,
    exportPdf,
};

const MODULE = {
    PHONE_EXT: 'phone-exts',
};

const API_URL = API.BASE_URL_API + '/v1';

export function getAll (filter) {
    const request = {
        params: {
            location_uuid: filter?.locationUuid,
            is_active: filter?.isActive,
            page: filter?.pageNumber,
            size: filter?.pageSize,
        },
    };

    let array = filter?.searchArray;
    array?.forEach((word, index) => {
        if (word != null || word != '') {
            var searchParam = `search_words[${index}]`;
            request.params[searchParam] = word;
        }
    });

    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT}`, request);
}

export function store (data) {
    const request = {
        location_uuid: data.locationUuid,
        name: data.name,
        date: data.date,
    };

    return apiHelper(API_URL).post(`/${MODULE.PHONE_EXT}`, request);
}

export function show (uuid) {
    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT}/${uuid}`);
}

export function update (data) {
    const request = {
        location_uuid: data.locationUuid,
        name: data.name,
        date: data.date,
    };

    return apiHelper(API_URL).put(`/${MODULE.PHONE_EXT}/${data.uuid}`, request);
}

export function updateStatus (data) {
    const request = {
        is_active: data.isActive,
    };

    return apiHelper(API_URL).patch(`/${MODULE.PHONE_EXT}/${data.uuid}`, request);
}

export function exportPdf (data) {
    const request = {
        params: { uuid: data?.uuid },
        responseType: 'blob',
    };

    return apiHelper(API_URL).get(`/${MODULE.PHONE_EXT}/export-pdf`, request);
}